import { render, staticRenderFns } from "./BusinessAddress.vue?vue&type=template&id=1a74075b&scoped=true&"
import script from "./BusinessAddress.vue?vue&type=script&lang=js&"
export * from "./BusinessAddress.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAddress.vue?vue&type=style&index=0&id=1a74075b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a74075b",
  null
  
)

export default component.exports